export const DATA_STATUS_DONE = 'done';
export const DATA_STATUS_PROCESSING = 'processing';
export const DATA_STATUS_NONE = 'none';

export const DATA_DONE_TEXT = '完了';
export const DATA_PROCESSING_TEXT = '集計中';
export const DATA_NONE_TEXT = 'Data無';

export const DATA_STATUS_TEXT = {
  [DATA_STATUS_DONE]: '完了',
  [DATA_STATUS_PROCESSING]: '集計中',
  [DATA_STATUS_NONE]: 'Data無',
};
